//IMPORTANT: need to remove the "dist" from the path
import '@shoelace-style/shoelace/dist/components/drawer/drawer.js';
// import "@shoelace-style/shoelace/dist/components/select/select.js";
import '@shoelace-style/shoelace/dist/components/progress-bar/progress-bar.js';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';
import '@shoelace-style/shoelace/dist/components/rating/rating.js';
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import '@shoelace-style/shoelace/dist/components/dialog/dialog.js';
import '@shoelace-style/shoelace/dist/components/select/select.js';
import '@shoelace-style/shoelace/dist/components/option/option.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import '@shoelace-style/shoelace/dist/components/spinner/spinner.js';
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import '@shoelace-style/shoelace/dist/components/include/include.js';
import '@shoelace-style/shoelace/dist/components/details/details.js';

// vendor libs
import Alpine from 'alpinejs'
import * as cart from '@shopify/theme-cart';
import axios from 'axios';

// all fusion core
import { pdpCore } from './framework/fusion-pdp/pdp-core';
import { modalCore } from './utils/modalCore';
import { initFusionPdpSlider, handleVpChange } from './framework/fusion-pdp/pdp-slider';
import { fusionReveal } from './utils/animations';

import { initInfluencerStorefront } from './framework/fusion-inf/inf-main';

document.addEventListener("DOMContentLoaded", () => {


	console.log("Fusion Framework Loaded");
	// !important don't fux with this
	const currentTemplate = document.getElementById("FusionFrameworkInit");

	// ! Important: all elements that need to be intereacted in the DOM need to go here
	// register DOM elements for use
	window.fusionElements = {
		drawer: document.querySelector(".fusion-cart__drawer"),
		cartError: document.getElementById("fusionCartAlert"),
		modal: document.getElementById("fusionModalMain"),
		mobileQuickShopDrawer: document.getElementById("fusionQuickShopDrawer"),
		showQuickShopDrawer: false,
		showUpsell: false

	};

	let initUpsellDisplay = localStorage.getItem("showUpsell");
	if (initUpsellDisplay) {
		window.fusionElements.showUpsell = JSON.parse(initUpsellDisplay);
	}

	Alpine.store("cart", {
		recs: {
			product_id: window.theme.fusion_recs.product_id
		},
		cartData: {},
		cartItems: [],
		cartCount: 0,
		cartError: {
			id: "",
			message: "",
		},
		updateCartState(newCartData) {
			this.cartData = newCartData;
			this.cartItems = newCartData.items;
			this.cartCount = newCartData.item_count;
		},
		updateCartError(id, message) {
			this.cartError = {
				id: id,
				message: message,
			};
		},
	});



	// set init cart state
	cart.getState().then((cartState) => {
		fetch('/cart?view=json')
			.then(response => response.json())
			.then(data => {
				let newCartData = JSON.parse(data)
				cartState.total_savings = 0; // Initialize total savings to zero
				cartState.items.forEach((item) => {
					const variantToUpdate = newCartData.find(o => o.id === item.id);
					if (variantToUpdate && variantToUpdate.compare_at_price !== undefined) {
						item.compare_at_price = variantToUpdate.compare_at_price;
						item.is_on_sale = true;
						const savings = (item.compare_at_price - item.price) * item.quantity;
						cartState.total_savings += savings;
					} else {
						item.compare_at_price = null;
						item.is_on_sale = false;
					}
				});
				Alpine.store("cart").updateCartState(cartState);

			}).catch(error => console.error('Error fetching JSON:', error));
	});

	Alpine.store("fusionQuickShop", {
		productObject: "",
		updateProductObject(data) {
			this.productObject = data;
		},
	});


	localStorage.getItem("INF_STATUS");
	let currentInfStatus = localStorage.getItem("INF_STATUS");
	if (currentInfStatus == "true") {

		let rawINF = JSON.parse(localStorage.getItem("INF_SELECTION"));

		Alpine.store("infSelector", {
			isActive: true,
			activeList: {
				listName: rawINF.listName,
				listHandle: rawINF.listHandle,
				listProducts: rawINF.listProducts,
				listProductsJson: rawINF.listProductsJson,
				listId: rawINF.listId,
				createdAt: rawINF.createdAt,
				updatedAt: rawINF.updatedAt,
			},
			addProduct(eventData) {
				console.log(eventData);
				const productObject = JSON.parse(eventData.detail);

				// Check if the product already exists based on ID
				const productExists = this.activeList.listProductsJson.some(product => product.id === productObject.id);

				if (!productExists) {
					console.log("Adding product:", productObject);
					this.activeList.listProductsJson.unshift({
						title: productObject.title,
						handle: productObject.handle,
						imageUrl: productObject.imgUrl,
						id: productObject.id,
					});

					this.activeList.listProducts.unshift(productObject.handle);

					localStorage.setItem("INF_SELECTION", JSON.stringify(Alpine.raw(Alpine.store("infSelector").activeList)));

					console.log("active", Alpine.raw(Alpine.store("infSelector")));
					// Get the element and trigger the animation
					let yeet = document.getElementById('infSelectSuccessPop');
					if (yeet) {
						yeet.style.transform = 'translate-y(-33px)';
						console.log(yeet)

						// Add the animation class
						yeet.style.animation = "slideUpDown 2.5s ease-in-out forwards";

						// Remove the active class and animation after the animation is complete
						setTimeout(() => {
							yeet.classList.remove('infSelectSuccessPopActive');
							yeet.style.animation = ""; // Reset the animation
						}, 2500); // Match this timing with the animation duration
					}
				} else {
					console.log("Product already exists:", productObject);
				}
			},
			removeProduct(eventData) {
				let rawJson = Alpine.raw(this.activeList.listProductsJson);
				let filterJson = rawJson.filter((o) => o.handle !== eventData.detail.handle);

				let rawHandles = Alpine.raw(this.activeList.listProducts);
				let filterHandles = rawHandles.filter((o) => o !== eventData.detail.handle);

				this.activeList.listProductsJson = filterJson;
				this.activeList.listProducts = filterHandles;

				localStorage.setItem("INF_SELECTION", JSON.stringify(Alpine.raw(Alpine.store("infSelector").activeList)));
			},
		});

	} else {
		Alpine.store("infSelector", {
			isActive: false,
			activeList: {},
			addProduct(eventData) {
				console.log(eventData);
				let productObject = eventData.detail;
				this.activeList.listProducts.push(productObject.handle);
				this.activeList.listProductsJson.push({
					title: productObject.title,
					handle: productObject.handle,
					imageUrl: `${productObject.images[0]}&width=50`,
					id: productObject.id,
				});
			},
		});
	}



	switch (currentTemplate.dataset.fusiontemplate) {
		case "product":
			// Init all product page related data
			Alpine.store("activeProduct", {
				activeProduct: window.fusionDataLayer.activeProduct,
				updateActiveProduct(data) {
					this.activeProduct = data;
				},
			});

			if (window.fusionDataLayer.activeProduct.product_option_titles.length > 1) {
				Alpine.store("vMultiSelect", {
					activeOptionOne: "",
					activeOptionTwo: "",
					updateActiveOptionOne(obj) {
						this.activeOptionOne = obj;
					},
					updateActiveOptionTwo(obj) {
						this.activeOptionTwo = obj;
					},
				});
			}

			// custom back in stock component
			Alpine.store("fusionBIS", {
				variantId: "",
				email: "",
				isLoading: false,
				displaySubmit: false,
				updateBisVariant(variantId) {
					this.variantId = variantId;
				},
				updateBisEmail(email) {
					this.email = email;
				},
				updateLoading(data) {
					this.isLoading = data;
				},
			});

			if (window.fusionDataLayer.activeProduct.variants.length == 1) {
				Alpine.store("selectedVariant", {
					id: window.fusionDataLayer.activeProduct.variants[0].id,
					title: "",
					displayAtc: true,
					updateActiveVariant(data) {
						(this.id = data.id), (this.title = data.title), (this.displayAtc = data.id !== "" ? true : false);
					},
				});
			} else {
				Alpine.store("selectedVariant", {
					id: "",
					title: "",
					displayAtc: false,
					updateActiveVariant(data) {
						(this.id = data.id), (this.title = data.title), (this.displayAtc = data.id !== "" ? true : false);
					},
				});
			}

			// handle resize of window for PDP slider
			window.addEventListener("resize", () => handleVpChange(window.innerWidth));

			// Automatically init slider under 900px view port width
			if (window.innerWidth <= 900) {
				// window.fusionElements.drawer.setAttribute("placement", "end");
				initFusionPdpSlider();
			} else {
				window.fusionDataLayer.activeSlider = false;
				// window.fusionElements.drawer.setAttribute("placement", "end");
			}

			// Animation fade in on PDP
			fusionReveal();

			// init F U S I O N // R A C T O R
			pdpCore();
			break;
		case "collection":
			// Init all collection data

			Alpine.store("selectedVariant", {
				id: "",
				title: "",
				displayAtc: false,
				updateActiveVariant(data) {
					(this.id = data.id), (this.title = data.title), (this.displayAtc = data.id !== "" ? true : false);
				},
			});

			break;
		default:
			Alpine.store("selectedVariant", {
				id: "",
				title: "",
				displayAtc: false,
				updateActiveVariant(data) {
					(this.id = data.id), (this.title = data.title), (this.displayAtc = data.id !== "" ? true : false);
				},
			});
	}

	// !IMPORTANT keep this at the end of the file or init errors will occur
	Alpine.start();
	window.Alpine = Alpine;
	initInfluencerStorefront();
	let infSfSelectorSummary = document.getElementById('infSfSelectorSummary');
	if (infSfSelectorSummary) {
		infSfSelectorSummary.addEventListener("sl-show", (e) => {
			e.target.classList.add('selectorSummaryOpen')
		});
	}
});

// Drawer hide and remove scroll lock
document.addEventListener("sl-after-hide", (e) => {
	if (e.target.id == "fusionQuickShopDrawer") {
		const quickshopImages = document.querySelectorAll(".fusion-quickshop_img");
		quickshopImages.forEach((element) => {
			element.classList.remove("lazyloaded");
			element.classList.remove("ls-is-cached");
			element.classList.add("lazyload");
		});
		document.querySelector("html").classList.remove("scroll-locked--custom");
	} else if (e.target.id == "fusionProductRecs") {
		localStorage.setItem("showUpsell", JSON.stringify(false));
		return;
	}

	document.querySelector("html").classList.remove("scroll-locked--custom");
});

// apply scroll lock on drawer and dialog and and expand for all other needs
document.addEventListener("sl-show", (e) => {
	const targetNode = e.target.nodeName;
	if (targetNode == "SL-DRAWER" || targetNode == "SL-DIALOG") {
		document.querySelector("html").classList.add("scroll-locked--custom");
	} else if (e.target.id == "fusionCartDrawer" || e.target.id == "fusionProductRecs") {
		document.querySelector("html").classList.add("scroll-locked--custom");
		localStorage.setItem("showUpsell", JSON.stringify(true));
	}
});

// handle all product removal from inside the cart component
document.addEventListener("removeCartProduct", async (e) => {
	const lineItemELm = document.getElementById(e.detail.lineKey);
	const lineItemKey = e.detail.lineKey;
	lineItemELm.classList.add("fusion__content-loading");

	try {
		const cartState = await cart.removeItem(lineItemKey);
		try {
			const response = await fetch('/cart?view=json');
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}

			const data = await response.json();
			let newCartData = JSON.parse(data);

			cartState.total_savings = 0; // Initialize total savings to zero
			cartState.items.forEach((item) => {
				const variantToUpdate = newCartData.find(o => o.id === item.id);
				if (variantToUpdate && variantToUpdate.compare_at_price !== undefined) {
					item.compare_at_price = variantToUpdate.compare_at_price;
					item.is_on_sale = true;
					const savings = (item.compare_at_price - item.price) * item.quantity;
					cartState.total_savings += savings;
				} else {
					item.compare_at_price = null;
					item.is_on_sale = false;
				}
			});

			Alpine.store("cart").updateCartState(cartState);
		} catch (fetchError) {
			console.error('Error fetching JSON:', fetchError);
			Alpine.store("cart").updateCartState(cartState);
		}
	} catch (cartError) {
		console.log("Cart Err", cartError);
		Alpine.store("cart").updateCartError(e.detail.lineKey, "Unable to perform action");
	} finally {
		lineItemELm.classList.remove("fusion__content-loading");
	}
});


// handle removing a specific line item from the cart
document.addEventListener("decreaseCartQuantity", (e) => {
	const lineItemELm = document.getElementById(e.detail.lineKey);
	const lineItemKey = e.detail.lineKey;
	const lineItemQuantity = e.detail.quantity;
	lineItemELm.classList.add("fusion__content-loading");

	cart
		.updateItem(lineItemKey, { quantity: lineItemQuantity - 1 })
		.then((cartState) => {

			try {
				fetch('/cart?view=json')
					.then(response => response.json())
					.then(data => {
						let newCartData = JSON.parse(data)
						cartState.total_savings = 0; // Initialize total savings to zero
						cartState.items.forEach((item) => {
							const variantToUpdate = newCartData.find(o => o.id === item.id);
							if (variantToUpdate && variantToUpdate.compare_at_price !== undefined) {
								item.compare_at_price = variantToUpdate.compare_at_price;
								item.is_on_sale = true;
								const savings = (item.compare_at_price - item.price) * item.quantity;
								cartState.total_savings += savings;
							} else {
								item.compare_at_price = null;
								item.is_on_sale = false;
							}
						});
						lineItemELm.classList.remove("fusion__content-loading");

						Alpine.store("cart").updateCartState(cartState);

					}).catch(error => {
						Alpine.store("cart").updateCartState(cartState);
						lineItemELm.classList.remove("fusion__content-loading");
						console.error('Error fetching JSON:', error)
					});
			} catch (error) {
				console.error('Error fetching JSON:', error)
			}
		})
		.catch((err) => {
			console.log("Cart Err", err);
			Alpine.store("cart").updateCartError(e.detail.lineKey, "Unable To Prefrom Action");
			lineItemELm.classList.remove("fusion__content-loading");
		});
});

// handle all quantity increases in the cart on a specific line item
document.addEventListener("increaseCartQuantity", (e) => {
	const lineItemELm = document.getElementById(e.detail.lineKey);
	const lineItemKey = e.detail.lineKey;
	const lineItemQuantity = e.detail.quantity;
	lineItemELm.classList.add("fusion__content-loading");

	if (lineItemQuantity <= 7) {
		cart
			.updateItem(lineItemKey, { quantity: lineItemQuantity + 1 })
			.then((cartState) => {
				try {
					fetch('/cart?view=json')
						.then(response => response.json())
						.then(data => {
							console.log(data)
							let newCartData = JSON.parse(data)
							cartState.total_savings = 0; // Initialize total savings to zero
							cartState.items.forEach((item) => {
								const variantToUpdate = newCartData.find(o => o.id === item.id);
								if (variantToUpdate && variantToUpdate.compare_at_price !== undefined) {
									item.compare_at_price = variantToUpdate.compare_at_price;
									item.is_on_sale = true;
									const savings = (item.compare_at_price - item.price) * item.quantity;
									cartState.total_savings += savings;
								} else {
									item.compare_at_price = null;
									item.is_on_sale = false;
								}
							});
							lineItemELm.classList.remove("fusion__content-loading");

							Alpine.store("cart").updateCartState(cartState);

						}).catch(error => {
							Alpine.store("cart").updateCartState(cartState);
							lineItemELm.classList.remove("fusion__content-loading");
							console.error('Error fetching JSON:', error)
						});
				} catch (error) {
					console.error('Error fetching JSON:', error)
				}
			})
			.catch((err) => {
				console.log("Cart Err", err);
				Alpine.store("cart").updateCartError(e.detail.lineKey, "Unable To Prefrom Action");
				lineItemELm.classList.remove("fusion__content-loading");
			});
	} else {
		Alpine.store("cart").updateCartError(e.detail.lineKey, "Maximum Quantity Reached");
		lineItemELm.classList.remove("fusion__content-loading");
	}
});

// Global for all modal name needs to equal the ID of the specific modal IE: 'sizeGuideModal'
document.addEventListener("openFusionModal", (e) => {
	modalCore(e.detail.modalName);
});

// Drawer hide and remove scroll lock
document.addEventListener("sl-hide", (e) => {
	if (e.target.nodeName == "SL-DIALOG") {
		document.querySelector(".fusion-modal-wrapper--active").classList.add("fusion-modal-wrapper--hidden");
	}
});

document.addEventListener("plpAtc", (event) => {
	if (!event.target.id) return;

	let tmp = event.target.getAttribute("data-product-id-v");
	let parentTest = document.querySelectorAll(`[data-product-id="${tmp}"]`);
	let finalElmGlobal = "";

	if (window.fusionElements.drawer.hasAttribute("open")) {
		if (parentTest.length) {
			parentTest.forEach((o, i) => {
				if (o.dataset.cardtype == "upsell") {
					o.classList.add("fusion__content-loading");
					finalElmGlobal = o;
					return o;
				}
			});
		}
	} else {
		let finalElm = parentTest[0];
		finalElm.classList.add("fusion__content-loading");
		finalElmGlobal = finalElm;
	}

	cart.addItem(parseInt(event.target.id), { quantity: 1 }).then((item) => {
		cart.getState().then((cartState) => {
			// Update alpine cart state
			fetch('/cart?view=json')
				.then(response => response.json())
				.then(data => {
					let newCartData = JSON.parse(data)
					cartState.total_savings = 0; // Initialize total savings to zero
					cartState.items.forEach((item) => {
						const variantToUpdate = newCartData.find(o => o.id === item.id);
						if (variantToUpdate && variantToUpdate.compare_at_price !== undefined) {
							item.compare_at_price = variantToUpdate.compare_at_price;
							item.is_on_sale = true;
							const savings = (item.compare_at_price - item.price) * item.quantity;
							cartState.total_savings += savings;
						} else {
							item.compare_at_price = null;
							item.is_on_sale = false;
						}
					});
					Alpine.store("cart").updateCartState(cartState);
					// open cart drawer on next tick to ensure data quality
					Alpine.nextTick(() => window.fusionElements.drawer.show());
					finalElmGlobal.classList.remove("fusion__content-loading");

				}).catch(error => console.error('Error fetching JSON:', error));
		});
	});
});

document.addEventListener("closeBisModal", (event) => {
	let bisEmailInput = document.getElementById("fusionBisEmail");
	bisEmailInput.value = "";

	// hide modal
	window.fusionElements.modal.hide();
});

document.addEventListener("handleBIS", async () => {
	try {
		Alpine.store("fusionBIS").updateLoading(true);

		const payload = {
			"data": {
				"type": "back-in-stock-subscription",
				"attributes": {
					"profile": {
						"data": {
							"type": "profile",
							"attributes": {
								"email": Alpine.store("fusionBIS").email
							}
						}
					},
					"channels": ["EMAIL"]
				},
				"relationships": {
					"variant": {
						"data": {
							"type": "catalog-variant",
							"id": `$shopify:::$default:::${Alpine.store("fusionBIS").variantId}`
						}
					}
				}
			}
		};

		const response = await fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=RpWxXa", {
			method: 'POST',
			headers: {
				"Content-Type": "application/json",
				"revision": "2024-06-15"
			},
			body: JSON.stringify(payload)
		});

		if (!response.ok) {
			const errorData = await response.json();
			throw errorData;
		}

		// Success handling
		setTimeout(() => {
			window.fusionElements.modal.hide();
			Alpine.store("fusionBIS").updateLoading(false);
			setTimeout(() => {
				alert("Successfully Signed Up!");
			}, 300);
		}, 1600);
	} catch (error) {
		console.error("Error:", error);
		alert("Error Submitting Sign Up");
		Alpine.store("fusionBIS").updateLoading(false);
	}
});

document.addEventListener("mobileQuickShop", (e) => {
	Alpine.store("fusionQuickShop").updateProductObject(e.detail);
	window.fusionElements.showQuickShopDrawer = true;

	window.fusionElements.mobileQuickShopDrawer.show();

	if (e.detail.variants.length == 1) {
		Alpine.store("selectedVariant").updateActiveVariant({
			id: e.detail.variants[0].id,
			title: "Add To Cart",
			displayAtc: true,
		});
	}
	pdpCore();
});



